<template>
    <div style="display: inline;">
        <EmployeeDiscountForm
            v-if="checkEmployeeDiscount()"
            :employee-discount="employee_discount"
            :employee-discount-type="employee_discount_type"
            :employee-discount-value="employee_dsicount"
            :remove-discount="remove_discount"
            :apply-employee-discount-url="apply_employee_discount_url"
            :course-details-fields="courseDetailsFields()"
            :tra="tra"
            :data-obj="data_obj"
            @update-discount-type="change_employee_discount_type"
            @remove-discount="remove_discount = 1"
        />

        <div id="accordion" class="sticky-top pt-4">
            <div class="bg-white py-4 rounded-10">
                <PriceInfoHeader
                    :data-obj="data_obj"
                    :tra="tra"
                    :app-name="app_name"
                    @browse-courses="AllCoursesPopUpVraibalesAdding()"
                />

                <CourseDetailsDisplay
                    :data-obj="data_obj"
                    :course-weeks="course_weeks"
                    :tra="tra"
                    :app-name="app_name"
                />

                <BookingForm
                    :data-obj="data_obj"
                    :start-date="start_date"
                    :course-weeks="course_weeks"
                    :residence-weeks="residence_weeks"
                    :weeks-count="weeks_count"
                    :residences-obj="residencesObj"
                    :airports-obj="airportsObj"
                    :residence-id="residence_id"
                    :airport-id="airport_id"
                    :insurance-checker="insurance_checker"
                    :visa-checker="visa_checker"
                    :students-number="students_number"
                    :have-coupon="have_coupon"
                    :coupon-code="coupon_code"
                    :coupon-status="coupon_status"
                    :compare-offer="compare_offer"
                    :disabled-vacation-dates="disabledVacationDates"
                    :post-errors="post_errors"
                    :save-request-url="save_request_url"
                    :csrf-token="csrf_token"
                    :institute-id="institute_id"
                    :course-id="course_id"
                    :is-admin="is_admin"
                    :request-id="request_id"
                    :add-new-student-request-obj="add_new_student_request_obj"
                    :tra="tra"
                    :app-name="app_name"
                    :custom-residence="custom_residence"
                    @update-start-date="start_date = $event"
                    @update-course-weeks="course_weeks = $event"
                    @update-residence-weeks="residence_weeks = $event"
                    @update-residence-id="residence_id = $event"
                    @update-airport-id="airport_id = $event"
                    @update-insurance-checker="insurance_checker = $event"
                    @update-visa-checker="visa_checker = $event"
                    @update-students-number="students_number = $event"
                    @update-have-coupon="have_coupon = $event"
                    @update-coupon-code="coupon_code = $event"
                    @update-compare-offer="compare_offer = $event"
                    @institute-vacation-check="institute_vacation_checker"
                    @apply-coupon="apply_coupon"
                    @remove-coupon="remove_coupon"
                    @invoice="invoice"
                    @save-new-student-offer="save_new_student_offer"
                    @submit-with-request-id="sub_form_with_request_id"
                />

                <button 
                    @click="goToRelatedCourse()" 
                    id="related-courses"
                    class="d-lg-none d-block btn rounded-10 bg-main-color text-white mb-2 w-100 mt-5"
                >
                    {{ tra.available_courses_options }}
                </button>
            </div>
        </div>

        <ResidenceModal
            :residences-obj="residencesObj"
            :residence-id="residence_id"
            :select-residence-age="selectResidenceAge"
            :custom-residence="custom_residence"
            :weeks-count="weeks_count"
            :is-admin="is_admin"
            :tra="tra"
            @update-residence-id="residence_id = $event"
            @update-select-residence-age="selectResidenceAge = $event"
            @update-custom-residence="custom_residence = $event"
            @choose-custom-residence="choosingCustomResidence"
            @residence-change="ResidencesChangeHandeler"
        />

        <VacationModal
            v-if="vacationModal"
            :vacation="vacation"
            :residence-id="residence_id"
            :tra="tra"
            @hide-modal="hide_vacation_modal"
            @add-vacation-weeks="add_vacation_weeks"
        />

        <SaveOfferModal
            :save-student-offer-url="save_student_offer_url"
            :csrf-token="csrf_token"
            :course-details-fields="courseDetailsFields()"
            :post-errors="post_errors"
            :tra="tra"
        />
    </div>
</template>

<script>
import EmployeeDiscountForm from './EmployeeDiscountForm.vue';
import PriceInfoHeader from './PriceInfoHeader.vue';
import CourseDetailsDisplay from './CourseDetailsDisplay.vue';
import BookingForm from './BookingForm.vue';
import ResidenceModal from './ResidenceModal.vue';
import VacationModal from './VacationModal.vue';
import SaveOfferModal from './SaveOfferModal.vue';

export default {
    name: 'CourseBooking',
    components: {
        EmployeeDiscountForm,
        PriceInfoHeader,
        CourseDetailsDisplay,
        BookingForm,
        ResidenceModal,
        VacationModal,
        SaveOfferModal,
    },
    props: [
        "course_price_info_url",
        "csrf_token",
        'institute_courses_count',
        'post_errors',
        'is_admin',
        "old",
        "save_request_url",
        "course_id",
        "institute_id",
        "institute_vacation_checker_url",
        "check_coupon_url",
        "apply_employee_discount_url",
        "get_employee_discount_url",
        "employee_discount",
        "save_student_offer_url",
        "add_new_student_request",
        "pref_currency",
        "tra"
    ],
    data() {
        return {
            data_obj: {
                course: { 
                    discount_obj: { 
                        discounts: {}, 
                        coupon: {} 
                    } 
                },
                residence: {},
                airport: {},
                visa: {},
                airports: [],
                residences: [],
                currency: { code: 'SAR' },
                total_price: 0,
                insurance: 0,
                insurance_price: 0,
            },
            residence_id: '',
            custom_residence: {
                description: this.old?.custom_residence?.description ?? '',
                price: this.old?.custom_residence?.price ?? '',
            },
            airport_id: '',
            insurance_checker: '',
            course_weeks: 1,
            residence_weeks: 1,
            weeks_count: 52,
            start_date: new Date(new Date().setDate(new Date().getDate() + 7 + (1 + 7 - new Date().getDay()) % 7)),
            visa_checker: window.APP_NAME == 'sat-edu' ? '' : '0',
            vacation: '',
            have_coupon: '',
            coupon_code: '',
            coupon_status: '',
            employee_discount_type: '',
            employee_dsicount: 0,
            remove_discount: 0,
            request_id: '',
            request_id_field: 0,
            students_number: 1,
            compare_offer: false,
            add_new_student_request_obj: this.add_new_student_request ? JSON.parse(this.add_new_student_request) : false,
            selectResidenceAge: '',
            vacationModal: true,
            firstTimeChangeResWeeks: true,
            currency_code: 'SAR',
            app_name: window.APP_NAME,
            base_url: window.base_url,
            user_details: {},
            institute_vacations: [],
            disabledVacationDates: [],
            residencesObj: {},
            airportsObj: {},
            lang: window.current_locale,
        };
    },
    computed: {
        canFetchResidences() {
            return this.institute_id && this.residence_weeks && this.start_date;
        },
        
        sortedResidences() {
            if (!this.data_obj || !this.residencesObj || !Array.isArray(this.residencesObj)) {
                return [];
            }

            let filteredResidences = this.residencesObj;

            if (this.residencesObj.length > 0) {
                const selectedResidence = this.residencesObj.find(residence => residence.id == this.residence_id);
                if (selectedResidence) {
                    const minAge = selectedResidence.min_age;
                    if (minAge < 16) {
                        this.selectResidenceAge = 'under_16';
                    } else {
                        this.selectResidenceAge = minAge;
                    }
                }
            }

            if (filteredResidences.length > 0) {
                if (this.selectResidenceAge == 'under_16') {
                    filteredResidences = filteredResidences.filter(residence => residence.min_age < 16);
                }
                if (this.selectResidenceAge == 16) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age == 16 ||
                        (residence.min_age < 16 && (residence.max_age == null || residence.max_age >= 16))
                    );
                }
                if (this.selectResidenceAge == 17) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age == 17 ||
                        (residence.min_age < 17 && (residence.max_age == null || residence.max_age >= 17))
                    );
                }
                if (this.selectResidenceAge == 18) {
                    filteredResidences = filteredResidences.filter(residence =>
                        residence.min_age >= 18 || (residence.max_age == null || residence.max_age >= 18)
                    );
                }
                if (this.selectResidenceAge == '') {
                    filteredResidences = filteredResidences.filter(residence => false);
                }
            }

            const sortingOrder = [
                'family_accommodation',
                'student_housing',
                'private_studio'
            ];

            if (filteredResidences.length > 0) {
                return filteredResidences.sort((a, b) => {
                    const indexA = sortingOrder.indexOf(a.residence_type);
                    const indexB = sortingOrder.indexOf(b.residence_type);
                    return indexA - indexB;
                });
            } else {
                return filteredResidences;
            }
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        },

        courseDetailsFields() {
            return `
                <input type="hidden" name="institute_id" value="${this.institute_id}">
                <input type="hidden" name="course_id" value="${this.course_id}">
                <input type="hidden" name="course_slug" value="${this.data_obj.course.course_slug || ''}">
                <input type="hidden" name="institute_slug" value="${this.data_obj.course.institute_slug || ''}">
                <input type="hidden" name="course_weeks" value="${this.course_weeks}">
                <input type="hidden" name="start_date" value="${this.formatDate(this.start_date)}">
                <input type="hidden" name="insurance" value="${this.insurance_checker}">
                <input type="hidden" name="insurance_checker" value="${this.insurance_checker}">
                <input type="hidden" name="insurance_price" value="${this.data_obj.insurance}">
                <input type="hidden" name="insurance_price_value" value="${this.data_obj.insurance_price}">
                <input type="hidden" name="residence_id" value="${this.residence_id == '0' ? '' : this.residence_id} ">
                <input type="hidden" name="residence_weeks" value="${this.residence_weeks}">
                <input type="hidden" name="airport_id" value="${this.airport_id == '0' ? '' : this.airport_id}">
                ${this.data_obj.visa != 0 ? `<input type="hidden" name="visa_checker" value="${this.visa_checker}">` : ''}
            `;
        },

        // API Methods
        get_course_price_info() {
            if (!this.course_price_info_url) return;
            
            axios.get(this.course_price_info_url, {
                params: {
                    course_id: this.course_id,
                    institute_id: this.institute_id,
                    start_date: this.formatDate(this.start_date),
                    course_weeks: this.course_weeks,
                    residence_id: this.residence_id,
                    custom_residence: this.residence_id == 'custom_residence' ? this.custom_residence : '',
                    residence_weeks: this.residence_weeks,
                    airport_id: this.airport_id,
                    insurance_checker: this.insurance_checker,
                    visa_checker: this.visa_checker,
                    currency_code: this.currency_code,
                    lang: this.lang,
                    coupon_code: this.coupon_status == 'true' ? this.coupon_code : '',
                },
            }).then((response) => {
                this.data_obj = {
                    ...this.data_obj,
                    ...response.data,
                    residences: response.data.residences || [],
                    airports: response.data.airports || [],
                    course: {
                        ...this.data_obj.course,
                        ...response.data.course,
                        discount_obj: {
                            discounts: {},
                            coupon: {},
                            ...response.data.course?.discount_obj
                        }
                    }
                };
            }).catch((error) => {
                console.error('Error fetching course price info:', error);
            });
        },

        get_employee_discount() {
            if (!this.get_employee_discount_url) return;
            
            axios.get(this.get_employee_discount_url)
                .then(response => {
                    if (response.data.discount_type) {
                        this.employee_dsicount = response.data.discount
                        this.employee_discount_type = response.data.discount_type
                    }
                })
                .catch(error => {
                    console.error('Error fetching employee discount:', error);
                });
        },

        get_user_details() {
            if (!this.base_url) return;
            
            axios.get(this.base_url + '/get-user-details')
                .then(response => {
                    this.user_details = response.data.user || {};
                })
                .catch(error => {
                    console.error('Error fetching user details:', error);
                    this.user_details = {};
                });
        },

        getResidences() {
            if (!this.canFetchResidences || !this.base_url) return;

            axios.get(this.base_url + '/api/get-residences', {
                params: {
                    institute_id: this.institute_id,
                    residence_weeks: 1,
                    start_date: this.formatDate(this.start_date),
                    lang: this.lang,
                },
            }).then((response) => {
                this.residencesObj = Array.isArray(response.data) ? response.data : [];
            }).catch((error) => {
                console.error('Error fetching residences:', error);
                if (error.response && error.response.status === 429) {
                    console.warn('Rate limit exceeded for residences. Retrying in 2 seconds...');
                    setTimeout(() => {
                        this.getResidences();
                    }, 2000);
                }
            });
        },

        getAirports() {
            if (!this.base_url) return;
            
            axios.get(this.base_url + '/api/get-airports', {
                params: {
                    institute_id: this.institute_id,
                    pref_currency: this.pref_currency,
                    lang: this.lang,
                },
            }).then((response) => {
                this.airportsObj = response.data
            }).catch((error) => {
                console.error('Error fetching airports:', error);
            });
        },

        getInstituteVacation() {
            if (!this.institute_id || !this.base_url) return;

            axios.get(this.base_url + '/api/get-institute-vacation', {
                params: {
                    institute_id: this.institute_id,
                    lang: this.lang,
                },
            }).then((response) => {
                this.institute_vacations = response.data;
                this.generateDisabledVacationDates();
            }).catch((error) => {
                console.error('Error fetching vacation:', error);
            });
        },

        // Business Logic Methods
        change_employee_discount_type() {
            if (this.employee_discount_type == "percentage") {
                if (this.employee_dsicount > 100) {
                    this.employee_dsicount = 0;
                }
            }
        },

        choosingCustomResidence() {
            $('#residences-modal').modal('hide');
            this.residence_id = 'custom_residence';
            this.get_course_price_info()
        },

        institute_vacation_checker() {
            if (!this.institute_vacation_checker_url) return;

            axios.get(this.institute_vacation_checker_url, {
                params: { 
                    institute_id: this.institute_id, 
                    date: this.formatDate(this.start_date), 
                    weeks: this.course_weeks,
                    lang: this.lang,
                },
            }).then((response) => {
                this.vacation = response.data

                if (this.vacation != '' && this.vacation.weeks > 0) {
                    $('#institute_vacation_checker_modal').modal('show')
                }
            }).catch((error) => {
                console.error('Error checking institute vacation:', error);
            });
        },

        apply_coupon() {
            if (!this.coupon_code) {
                if (window.sweet_alert_msg) {
                    window.sweet_alert_msg(this.tra.enter_discount_code || 'برجاء ادخال كوبون الخصم', "error");
                }
                return;
            }
            
            if (!this.check_coupon_url) return;
            
            axios.get(this.check_coupon_url, {
                params: { coupon_code: this.coupon_code },
            }).then((response) => {
                response = response.data
                if (response.status == "error") {
                    if (window.sweet_alert_msg) {
                        window.sweet_alert_msg(response.status_msg, "error");
                    }
                } else {
                    this.coupon_status = 'true';
                    this.get_course_price_info()
                    if (window.sweet_alert_msg) {
                        window.sweet_alert_msg("تم تطبيق كود الخصم بنجاح", "success");
                    }
                }
            }).catch((error) => {
                console.error('Error applying coupon:', error);
                if (window.sweet_alert_msg) {
                    window.sweet_alert_msg('حدث خطأ في تطبيق كود الخصم', "error");
                }
            });
        },

        remove_coupon() {
            this.coupon_status = '';
            this.coupon_code = '';
            this.get_course_price_info()
            if (window.sweet_alert_msg) {
                window.sweet_alert_msg("تم حذف كود الخصم ", "error");
            }
        },

        // Utility Methods
        checkEmployeeDiscount() {
            if (this.user_details && this.user_details.roles && this.user_details.permissions &&
                (this.user_details.roles.includes('admin') || this.user_details.permissions.includes('employee-discount-create'))) {
                return true;
            }
            return false;
        },

        generateDisabledVacationDates() {
            this.disabledVacationDates = [];
            if (this.institute_vacations && Array.isArray(this.institute_vacations)) {
                this.institute_vacations.forEach(institute_vacations => {
                    const fromDate = new Date(institute_vacations.from_date);
                    const toDate = new Date(institute_vacations.to_date);

                    if (fromDate instanceof Date && toDate instanceof Date && !isNaN(fromDate) && !isNaN(toDate)) {
                        for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
                            this.disabledVacationDates.push(new Date(date));
                        }
                    }
                });
            }
        },

        hide_vacation_modal() {
            $('#institute_vacation_checker_modal').modal('hide')
        },

        add_vacation_weeks() {
            if (this.vacation && this.vacation.weeks) {
                this.residence_weeks += this.vacation.weeks
            }
            $('#institute_vacation_checker_modal').modal('hide')
            this.vacationModal = false;
        },

        ResidencesChangeHandeler() {
            if (this.firstTimeChangeResWeeks) {
                this.residence_weeks = this.course_weeks
                this.firstTimeChangeResWeeks = false
            }
        },

        AllCoursesPopUpVraibalesAdding() {
            const vueInstance = this;

            $('.related-courses').each(function () {
                const anchor = $(this).find('a');
                if (anchor.length === 0) return;

                let href = anchor.attr('href');
                if (!href) href = '';

                if (href.includes('?')) {
                    href = href.split('?')[0];
                }

                const newParams = new URLSearchParams({
                    course_id: vueInstance.course_id,
                    institute_id: vueInstance.institute_id,
                    start_date: vueInstance.start_date,
                    course_weeks: vueInstance.course_weeks,
                    residence_id: vueInstance.residence_id,
                    custom_residence: vueInstance.residence_id == 'custom_residence' ? JSON.stringify(vueInstance.custom_residence) : '',
                    residence_weeks: vueInstance.residence_weeks,
                    airport_id: vueInstance.airport_id,
                    insurance_checker: vueInstance.insurance_checker,
                    visa_checker: vueInstance.visa_checker,
                    coupon_code: vueInstance.coupon_status == 'true' ? vueInstance.coupon_code : '',
                });

                const updatedHref = `${href}?${newParams.toString()}`;
                anchor.attr('href', updatedHref);
            });
        },

        change_to_get_requests() {
            let queryString = window.location.search;
            let savedParams = new URLSearchParams(queryString);

            let course_weeks = +savedParams.get('course_weeks')
            let start_date = savedParams.get('start_date')
            let insurance_checker = +savedParams.get('insurance_checker')
            let residence_id = +savedParams.get('residence_id')
            let residence_weeks = savedParams.get('residence_weeks')
            let airport_id = +savedParams.get('airport_id')
            let visa_checker = savedParams.get('visa_checker')
            this.request_id = savedParams.get('request_id')

            if (this.old && Object.keys(this.old).length !== 0) {
                course_weeks = this.old.course_weeks || course_weeks
                start_date = this.old.start_date || start_date
                residence_id = this.old.residence_id !== undefined ? this.old.residence_id : residence_id
                residence_weeks = this.old.residence_weeks || residence_weeks
                airport_id = this.old.airport_id !== undefined ? this.old.airport_id : airport_id
                visa_checker = this.old.visa_checker !== undefined ? this.old.visa_checker : visa_checker
                this.insurance_checker = this.old.insurance_checker !== undefined ? this.old.insurance_checker : this.insurance_checker
            }

            if (course_weeks) { this.course_weeks = course_weeks; }
            if (start_date !== undefined && start_date !== null) { this.start_date = new Date(start_date); }
            if (residence_id !== undefined && residence_id !== null) { this.residence_id = residence_id; }
            if (residence_weeks !== undefined && residence_weeks !== null) { this.residence_weeks = residence_weeks; }
            if (insurance_checker !== undefined && insurance_checker !== null) { this.insurance_checker = insurance_checker; }
            if (airport_id !== undefined && airport_id !== null) { this.airport_id = airport_id; }

            if (this.app_name != 'sat-edu') {
                this.visa_checker = '0';
            }
            else if (visa_checker == 'null' || this.app_name != 'sat-edu') {
                this.visa_checker = '0';
            } else if (visa_checker == undefined) {
                this.visa_checker = '';
            } else {
                this.visa_checker = visa_checker;
            }
        },

        goToRelatedCourse() {
            const relatedCoursesElement = $("#related-courses");
            if (relatedCoursesElement.length) {
                $('html, body').animate({ 
                    scrollTop: relatedCoursesElement.offset().top - 100 
                }, 500);
            }
        },

        invoice(data = null) {
            this.compare_offer = false;
            if (data && data['WASendOffer']) {
                $('.WASendOffer').attr('name', 'WASendOffer').val(1)
            }
            $('.invoice_checker').attr('name', 'invoice').val(1)
            $('.course-prices-form').attr('target', '_blank')
            setTimeout(function () {
                $('.invoice_checker').removeAttr('name', 'invoice')
                $('.WASendOffer').removeAttr('name', 'invoice')
                $('.course-prices-form').removeAttr('target');
            }, 1000);
        },

        save_new_student_offer() {
            if (this.add_new_student_request_obj && this.add_new_student_request_obj['student_id']) {
                $('.save_new_student_offer').attr('name', 'student_id').val(this.add_new_student_request_obj['student_id'])
            }
        },

        sub_form_with_request_id() {
            $('input[name="request_id"]').val(this.request_id)
            $('#course-prices-form').submit()
        },
    },
    watch: {
        course_weeks() {
            this.get_course_price_info()
            this.institute_vacation_checker()
            this.AllCoursesPopUpVraibalesAdding()
            
            if(this.residence_id){
                this.residence_weeks = this.course_weeks
            }
        },
        residence_weeks() {
            this.get_course_price_info()
            this.AllCoursesPopUpVraibalesAdding()
        },
        start_date() {
            this.get_course_price_info()
            this.AllCoursesPopUpVraibalesAdding()
            this.institute_vacation_checker()
        },
        residence_id() {
            this.get_course_price_info()
            if (this.residence_id != 0 && this.residence_id != 'custom_residence') {
                $('#residences-modal').modal('hide');
            }

            if (this.start_date != '') {
                this.institute_vacation_checker()
            }
            this.AllCoursesPopUpVraibalesAdding()
        },
        airport_id() {
            this.get_course_price_info()
            this.AllCoursesPopUpVraibalesAdding()
        },
        visa_checker() {
            this.get_course_price_info()
            this.AllCoursesPopUpVraibalesAdding()
        },
        insurance_checker() {
            this.get_course_price_info()
            this.AllCoursesPopUpVraibalesAdding()
        },
        currency_code() {
            this.get_course_price_info()
            this.AllCoursesPopUpVraibalesAdding()
        }
    },
    beforeMount() {
        this.get_course_price_info();
        this.change_to_get_requests();
        this.get_employee_discount()
        this.get_user_details()
        this.getResidences()
        this.getInstituteVacation()
        this.getAirports()

        window.setTimeout(() => {
            if (this.post_errors && (this.post_errors.name || this.post_errors.email)) {
                $('#save-offer-file').modal('show')
            }
        }, 800)
    },
};
</script>

<style scoped>
.p-datepicker.p-inputwrapper-filled{
    width: 100% !important;
}
</style>